import { forwardRef } from 'react'

import {
  FileButton,
  TextButton,
  CloseButton,
  MonthsButton,
  IconButton,
  OptionsButton,
  ButtonWrapper,
  SearchButton
} from './button.styles'
import ButtonTypes from './buttonTypes'
import CommonButtonProps from './buttonInterface'

const CommonButton = forwardRef<HTMLButtonElement, CommonButtonProps>(
  (props, ref) => {
    const { variant, size, children, ...rest } = props

    const renderButton = (ButtonComponent: React.ComponentType<any>) => {
      return (
        <ButtonComponent size={size} ref={ref} {...rest}>
          {children}
        </ButtonComponent>
      )
    }

    switch (variant) {
      case ButtonTypes.File:
        return renderButton(FileButton)
      case ButtonTypes.TileText:
        return renderButton(TextButton)
      case ButtonTypes.Close:
        return renderButton(CloseButton)
      case ButtonTypes.Date:
        return renderButton(MonthsButton)
      case ButtonTypes.Icon:
        return renderButton(IconButton)
      case ButtonTypes.Search:
        return renderButton(SearchButton)
      case ButtonTypes.Options:
        return renderButton(OptionsButton)
      case ButtonTypes.Wrapper:
        return renderButton(ButtonWrapper)
      default:
        return renderButton(TextButton)
    }
  }
)

export default CommonButton
